import { Chip } from '../ui'

/** Live state of a sensor device (ACRE zones today), from `sensor_state`. */
const SENSOR_STATE_TONE: Record<string, 'ok' | 'warn' | 'danger' | 'muted'> = {
  normal: 'ok',
  alarm: 'danger',
  tamper: 'warn',
  fault: 'warn',
  isolated: 'muted',
  inhibited: 'muted',
  unknown: 'muted',
}

export function SensorStateChip({ state, changedAt }: { state: string | null | undefined; changedAt?: string | null }) {
  if (!state) return null
  const title = changedAt ? `Since ${new Date(changedAt).toLocaleString('sv-SE')}` : undefined
  return (
    <span title={title}>
      <Chip tone={SENSOR_STATE_TONE[state] ?? 'muted'} label={state} />
    </span>
  )
}
